import { FIREBASE_AUTH, FIREBASE_DB, FIREBASE_STORAGE } from './config';

let initialized = false;

export async function initializeFirebase() {
  if (initialized) return true;

  try {
    // Verify services are initialized
    if (!FIREBASE_AUTH || !FIREBASE_DB || !FIREBASE_STORAGE) {
      throw new Error('Firebase services not properly initialized');
    }

    initialized = true;
    return true;
  } catch (error) {
    console.error('Failed to initialize Firebase:', error);
    return false;
  }
}